import {
  AppointmentReportsState,
  ConsultationTypeFilter,
  FilterField,
  FilterType,
  ScheduleStatus,
} from "@/models/reports/appointment";

export const typeOfConsultation = [
  { label: "In Clinic", value: ConsultationTypeFilter.IN_CLINIC },
  { label: "Video", value: ConsultationTypeFilter.VIDEO },
];

export const filterLabels: Record<FilterType, string> = {
  [FilterType.CLINIC_NAME]: "Clinic",
  [FilterType.CONSULTATION_TYPE]: "Consultation Type",
  [FilterType.STATUS]: "Status",
  [FilterType.PATIENT_TYPE]: "Patient Type",
};

export const appointmentStatusOptions = [
  { label: "Upcoming", value: "PENDING" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Cancelled", value: "CANCELLED" },
];

export const patientTypeOptions = [
  { label: "New", value: "new" },
  { label: "Old", value: "old" },
];

export const StatusColorMap: Record<ScheduleStatus, string> = {
  [ScheduleStatus.COMPLETED]: "#E9FFF0",
  [ScheduleStatus.CANCELLED]: "#FFEFEF",
  [ScheduleStatus.UPCOMING]: "#F2F6F7",
  [ScheduleStatus.PENDING]: "#FFF9E6",
};

export const StatusTextColorMap: Record<ScheduleStatus, string> = {
  [ScheduleStatus.COMPLETED]: "#019C36",
  [ScheduleStatus.CANCELLED]: "#DE1C1C",
  [ScheduleStatus.UPCOMING]: "#090909",
  [ScheduleStatus.PENDING]: "#D98300",
};

export const initialAppointmentReportsState: AppointmentReportsState = {
  page: 0,
  rowsPerPage: 10,
  isExporting: false,
  showDateRange: false,
  filters: {
    [FilterField.CLINIC]: "",
    [FilterField.STATUS]: "",
    [FilterField.PATIENT_TYPE]: "",
    [FilterField.CONSULTATION_TYPE]: "",
  },
};

export const FilterKeys = {
  PATIENT_TYPE: "patientType",
  CONSULTATION_TYPE: "consultationType",
  CLINIC: "clinic",
};

export const ConsultationTypeMap = {
  "1": "inClinic",
  "2": "videoConsultation",
};

export const KeyMap = {
  CLINICIDS: "clinicIds",
};
